import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom'
import $ from 'jquery';
import TopNav from '../components/TopNav';
import { Container, Button, lightColors } from 'react-floating-action-button'
import '../bootstrap';
import 'bootstrap-imageupload';
import TableInfoBar from './TableInfoBar';
import LoginModal from './modal/LoginModal';

class SelectMerchantMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            navHeight: "",
        }
        this.navRefs = React.createRef()
    }

    componentDidMount() {
        if (!this.props.isAdmin) {
            this.props.app.loadTableIfNull(this.props.tableId);
        }
        // this.props.app.loadTableIfNull(table_id);
        $(document).trigger('CategoryContent.componentDidMount.completed')
        this.updateNavHeight()
    }
    componentDidUpdate() {
        this.updateNavHeight()
    }

    updateNavHeight = () => {
        if (this.navRefs.current && this.navRefs.current.navHeight) {
            let latestNavHeight = parseInt(this.navRefs.current.navHeight) + "px"
            if (this.state.navHeight != latestNavHeight) {
                this.setState({
                    navHeight: latestNavHeight
                })
            }
        }
    }

    getModalDiv = () => {
        return (
            <div style={{ width: "100%" }}>
                <div id="category-name" className="category-modal-field">
                    {lang.category_name}
                    <input type="text" className="form-control" id="cname" placeholder={lang.hint_name} />
                </div>
                <div id="category-description" className="category-modal-field">
                    {lang.category_description}
                    <input type="text" className="form-control" id="cdesc" placeholder={lang.hint_description} />
                </div>
                <div id="category-image" className="category-modal-field imageupload">
                    {lang.category_image}
                    <div className="file-tab panel-body">
                        <label className="btn btn-default btn-file">
                            <span>{lang.browse}</span>
                            {/* <!-- The file is stored here. --> */}
                            <form id="myform">
                                <input type="file" name="fileToUpload" id="fileToUpload" />
                            </form>
                        </label>
                    </div>
                </div>
            </div>
        )
    }

    getMerchantMenuListing() {
        let merchantMenus = this.props.app.state.merchantMenus
        merchantMenus.sort(function(a,b) {return a.sort - b.sort})
        const defaultThumbnailImage = "/storage/menu_item_images/default.png"
        return merchantMenus.map((merchantMenu) => {
            let image_path = merchantMenu.getImageUrl() || defaultThumbnailImage
            let result = (
                <Route
                    key={merchantMenu.id}
                    render={({ history }) => (
                        <div
                            id={`merchant-menu-${merchantMenu.id}`}
                            onClick={() => {
                                this.props.app.setState({
                                    selectedMerchantMenuId: merchantMenu.id
                                }, () => {
                                    history.push(`/category/${this.props.match.params.tableQR}`)
                                    $(document).trigger('MerchantMenu.selected')
                                })
                            }}
                            className='grid-item card'
                            data-id={merchantMenu.id}>
                            <div className="card-image" style={{paddingTop: "66.66%", width: "100%", backgroundPosition: "center center", backgroundRepeat: "no-repeat", backgroundSize: "contain",backgroundImage: `url(${image_path})`}}>
                                {/* <img src={image_path} width="100%"></img> */}
                            </div>
                            <span style={{ display: "block" }}>
                                <h4 className="grid-title" style={{ marginBottom: "11px" }}>
                                    <b>
                                        {merchantMenu["name_" + window.selectedLang] || merchantMenu["name_en"]}
                                        <br/>
                                        {
                                            merchantMenu.time_start &&
                                            <span className="">{`${moment(merchantMenu.time_start, "HH:mm").format("hh:mm a")} - ${moment(merchantMenu.time_end, "HH:mm").format("hh:mm a")}`}</span>
                                        }
                                    </b>
                                </h4>
                            </span>
                        </div>
                    )} />
            )
            return result;
        })
    }

    render() {
        if (!this.props.app.state.table) {
            return null
        }
        let paddingTop = {}
        if (this.state.navHeight != "") {
            paddingTop = {
                paddingTop: this.state.navHeight
            }
        }

        if (this.props.app.state.selectedMerchantMenuId) {
            return <Redirect to={`/category/${this.props.match.params.tableQR}`} />
        }
        return (
            <div>
                {
                    <TopNav table={this.props.app.state.table}
                        ref={this.navRefs}
                        isAllowSearchbar={true}
                        title={lang.category}
                        orders={this.props.app.state.orders}
                        backLabel={lang.back} back="/table"
                        backButton={false}
                        pickup={this.props.app.state.table.pickup}
                        pin={this.props.app.state.current_session !== null && table_session_id !== null ? <button className="btn btn-primary btn-sm" onClick={this.showPinNumber}>{lang.show_pin}</button> : ''}
                        session={this.props.app.state.current_session}
                        tableQR={this.props.match.params.tableQR}
                        showCheckIn={!this.props.app.isMerchantHasFeature('disable_check_in')}
                    />
                }

                <div className="container body-content" style={{...paddingTop}}>
                    <TableInfoBar table={this.props.app.state.table} app={this.props.app} style={{ marginTop: "0px", marginBottom: "5px", backgroundColor: "white", marginLeft: "-15px", marginRight: "-15px", padding: "0px 15px" }} />
                    {
                        this.props.app.state.merchant && this.props.app.state.merchant.announcement_text &&
                        <div className="container-fluid marquee" style={{height: "25px", fontSize: "larger", fontFamily: "cursive", marginBottom: "10px"}}>
                            <div>
                                <span>{this.props.app.state.merchant.announcement_text}</span>
                                <span>{this.props.app.state.merchant.announcement_text}</span>
                            </div>
                        </div>
                    }

                    <div style={{textAlign: "center"}}>
                        <h3><strong>{lang.choose_menu}</strong></h3>
                    </div>
                    <div id="category-list" className="grid-container" style={{ paddingBottom: "50px", width: "100%", gridTemplateColumns: "calc(50% - 5px) calc(50% - 5px)" }}>
                        {this.getMerchantMenuListing()}
                    </div>
                </div>
            </div>
        );
    }
}

export default SelectMerchantMenu;